<template>
  <div>
    <div class="title">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/goodsStatistics',query:{shipDateId: shipDateId,shipName:shipName,shipDateNo:shipDateNo} }">返回上一级</el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="ship">
        <span>船舶名称：{{shipName}}</span>
        <span style="margin-left:30px">航次号：{{shipDateNo}}</span>
      </div>
    </div>
    <div class="inpBox">
      <el-form :inline="true" :model="formData" ref="formData" class="demo-form-inline">
        <el-form-item label="捆包号">
          <el-input placeholder="请输入" type="textarea" v-model="formData.cargoBarcodes" size="mini" rows="3"></el-input>
        </el-form-item>
        <el-form-item label="舱位号">
          <el-select v-model="formData.cargoHold" size="mini" placeholder="请选择">
            <el-option v-for="(item, index) in cwData" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排位号">
          <el-select v-model="formData.cargoArea" size="mini" placeholder="请选择">
            <el-option v-for="(item, index) in pwData" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="层位号">
          <el-select v-model="formData.cargoFloor" size="mini" placeholder="请选择">
            <el-option v-for="(item, index) in cengwData" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="货位号">
          <el-input v-model="formData.cargoBin" placeholder="请输入" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="客户名称">
          <el-input v-model="formData.customerName" placeholder="请输入" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="交货地">
          <el-input v-model="formData.receivingAddress" placeholder="请输入" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="货物状态">
          <el-select v-model="formData.goodsStatus" size="mini" placeholder="请选择">
            <el-option v-for="(item, index) in hwData" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <br />
        <el-form-item>
          <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi">重置</el-button>
          <el-button type="primary" size="mini" @click="daochu">导出</el-button>
        </el-form-item>
        <el-form-item>
          <span>总重量&nbsp;&nbsp;<span style="color:red">{{allWeight}}</span>&nbsp;吨</span>
          <span style="margin-left:10px">总件数&nbsp;&nbsp;<span style="color:red">{{allNumber}}</span>&nbsp;件</span>
        </el-form-item>
      </el-form>
    </div>
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData" style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row>
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="location" label="舱货位号" align="center" width="280"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center" width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="customerName" label="客户名称" align="center" width="250"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="goodsStatus" label="货位状态" align="center" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量（吨）" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center" width="80"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="receivingAddress" label="交货地" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="sign" label="标记" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="shipMentTime" label="装船时间" align="center" width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="shipUnloadTime" label="卸船时间" align="center" width="180"></el-table-column>
      </el-table>
    </div>
    <div class="pags" style="text-align: right">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
import { getShipGoodsLocationList, getShipGoodsLocationNw, getShipGoodsSelectList } from '@/api/shipping'
import { exportExcel } from '@/utils/fileDown.js'
export default {
  data () {
    return {
      formData: {
        cargoBarcodes: '',
        cargoHold: this.$route.query.cargoHold,
        cargoArea: '',
        cargoFloor: '',
        cargoBin: '',
        customerName: '',
        receivingAddress: '',
        goodsStatus: ''
      },
      cwData: [],
      pwData: [],
      cengwData: [],
      hwData: [
        {
          id: '',
          name: '全部'
        },
        {
          id: '1',
          name: '未装船'
        },
        {
          id: '2',
          name: '已装船'
        },
        {
          id: '3',
          name: '已卸船'
        }
      ],
      allWeight: '0',
      allNumber: '0',
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      tableData: [],
      total: 0,
      h: '400px',
      shipName: this.$route.query.shipName,
      shipDateNo: this.$route.query.shipDateNo,
      shipDateId: this.$route.query.shipDateId
    }
  },
  created () {
    this.chaxun()
    this.getShipGoodsSelectList()
  },
  methods: {
    // 列表
    getShipGoodsLocationList () {
      this.formData.cargoBarcodes = this.formData.cargoBarcodes.replace(/\n/g, ',')
      getShipGoodsLocationList(
        {
          ...this.formData,
          ...this.pageInfo,
          shipDateId: this.$route.query.shipDateId
        }
      ).then(res => {
        console.log(res)
        this.tableData = res.list
        this.total = res.total
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    // 重量
    getShipGoodsLocationNw () {
      this.formData.cargoBarcodes = this.formData.cargoBarcodes.replace(/\n/g, ',')
      getShipGoodsLocationNw(
        {
          ...this.formData,
          ...this.pageInfo,
          shipDateId: this.$route.query.shipDateId
        }
      ).then(res => {
        console.log(res)
        if (res == null) {
          this.allWeight = 0
          this.allNumber = 0
        } else {
          this.allWeight = res.totalWeight
          this.allNumber = res.totalNumber
        }
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    // 下拉框
    getShipGoodsSelectList () {
      getShipGoodsSelectList({
        shipDateId: this.$route.query.shipDateId,
        sele: '1'
      }).then(res => {
        console.log(res)
        this.cwData = res
      })
        .catch(error => {
          this.$message.error(error.message)
        })
      getShipGoodsSelectList({
        shipDateId: this.$route.query.shipDateId,
        sele: '2'
      }).then(res => {
        console.log(res)
        this.pwData = res
      })
        .catch(error => {
          this.$message.error(error.message)
        })
      getShipGoodsSelectList({
        shipDateId: this.$route.query.shipDateId,
        sele: '3'
      }).then(res => {
        console.log(res)
        this.cengwData = res
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    chaxun () {
      this.getShipGoodsLocationList()
      this.getShipGoodsLocationNw()
    },
    chongzhi () {
      this.formData = {
        cargoBarcodes: '',
        cargoHold: this.$route.query.cargoHold,
        cargoArea: '',
        cargoFloor: '',
        cargoBin: '',
        customerName: '',
        receivingAddress: '',
        goodsStatus: ''
      }
      this.pageInfo = {
        pageNo: 1,
        pageSize: 20
      }
      this.chaxun()
    },
    daochu () {
      this.formData.cargoBarcodes = this.formData.cargoBarcodes.replace(/\n/g, ',')
      exportExcel(
        this.global.shipping + '/goodsLocation/exportShipGoodsLocationList',
        { ...this.formData, ...this.pageInfo, shipDateId: this.$route.query.shipDateId },
        '货位统计详情表'
      )
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    }
  }
}
</script>

<style lang="less" scoped>
.el-breadcrumb {
  line-height: normal;
}
.title {
  display: flex;
  width: 100%;
  .ship {
    margin: 0 auto;
  }
}
.inpBox {
  .demo-form-inline {
    margin-top: 10px;
  }
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 10px;
  }
}
</style>
